/**
 * Created by:  phpStorm
 * Developer:   Pashkov Alexander
 * Upwork:      https://www.upwork.com/fl/alexanderpashkov
 * Email:       viplikensk@gmail.com
 * Site:        https://viplike.ru
 * Skype:       viplike_nsk
 * Date:        30.05.2020
 * Time:        15:24
 *
 * On business proposals, please write to the above contacts
 */
class FrontApp extends BaseModuleApp {

  // common handlers
  initCommonHandlers() {
    super.initCommonHandlers();

    // on click url
    const onClickUrlButtons = document.querySelectorAll('[data-on-click-url]');
    for (const onClickUrlButton of onClickUrlButtons) {
      onClickUrlButton.addEventListener('click', this.onClickUrl.bind(this, onClickUrlButton));
    }

    // download items with loader
    const downloadWithLoaderButtons = document.querySelectorAll('.download-with-loader-button');
    for (const downloadWithLoaderButton of downloadWithLoaderButtons) {
      downloadWithLoaderButton.addEventListener('click', this.onClickDownloadWithLoaderButton.bind(this, downloadWithLoaderButton));
    }

    // on sign out
    const signOutButtons = document.querySelectorAll('a[href="/auth/main/sign-out"]');
    for (const signOutButton of signOutButtons) {
      signOutButton.addEventListener('click', this.onClickSignOutButton.bind(this, signOutButton));
    }
  }

  // on click url
  onClickUrl(button) {
    location.href = button.dataset.onClickUrl;
  }

  // on click sign out button
  onClickSignOutButton(button, e) {
    localStorage.setItem('firebase-token', null);
  }

  // download with loader
  onClickDownloadWithLoaderButton(button, e) {
    // prevent default
    e.preventDefault();

    // show loader
    this.showLoader();

    // get url
    const url = button.getAttribute('href');

    // send result to the browser
    this.downloadFilesByUrls([url]).then(() => {
      // hide loader
      this.hideLoader();
    });
  }

  downloadFilesByUrls(urls) {
    return Promise.all(urls.map(this.downloadFileByUrl));
  }

  // download file
  downloadFileByUrl(url) {
    return new Promise(function (resolve, reject) {
      // Get file name from url.
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        resolve(xhr);
      };
      xhr.onerror = reject;
      xhr.open('GET', url);
      xhr.send();
    }).then(function (xhr) {
      var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
      var a = document.createElement('a');
      a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
      a.download = filename; // Set the file name.
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      return xhr;
    })
  }

}

// fire the front app
const frontApp = new FrontApp();




